export default class CallinStatusSerializer {
  static callInStatus(data){
    return{
      __type: data.__type,
      company_id: data.company_id,
      callin_status: data.callin_status,
      descr: data.descr,
      is_active: data.is_active,
      last_appt_req: data.last_appt_req,
      initiated_type: data.initiated_type
    };
  }

  static callInStatusesDeserializer(data) {
    return {
      callinStatus:  data.callinStatus.map(c => this.callInStatus(c))
    };
  }

}